import { ReactComponent as LogoMobile } from './Icon_mobile.svg';
import { ReactComponent as LogoTablet } from './Icon_tablet.svg';
import { ReactComponent as LogoDesktop } from './Icon_desktop.svg';
import { DeviceType } from '../../types';

interface VkDatingLogo extends React.SVGProps<SVGSVGElement> {
  deviceType?: DeviceType;
}

export function VkDatingLogo(props: VkDatingLogo) {
  const { deviceType = 'mobile', ...rest } = props;

  if (deviceType === 'desktop') {
    return <LogoDesktop {...rest} />;
  }

  if (deviceType === 'tablet') {
    return <LogoTablet {...rest} />;
  }

  return <LogoMobile {...rest} />;
}
